var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-table",style:({
			'border-width': _vm.borderType === 'grid' ? '1px' : '0',
			'border-color': _vm.borderColor
		})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }